<template>
  <div @dblclick.stop.prevent="handleDbClick" class="no-result clearfix" :style="{...wrapperStyle, backgroundColor: bgColor}">
    <img src="static/img/noresult.png" :style="imgStyle">
    <p class="tips" :style="{fontSize: fontSize}">{{tips}}</p>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
      color: '#81A3EB'
    }
  },
  props: {
    tips: {
      type: String,
      default: '暂无相关结果'
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    fontSize: {
      type: String,
      default: '16px'
    },
    imgStyle: {
      type: Object,
    },
    wrapperStyle: {
      type: Object,
      default: function () {
        return {
          height: '210px',
        }
      }
    }
  },
  methods: {
    handleDbClick () {
      console.log('被双击了');
      this.$emit('handleDbClick');
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '~@/styles/base.scss';
  .no-result {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 180px;
      height: auto;
    }
    .tips {
      margin-top: 10px;
      font-family: SimSun;
      color: #9c9c9c;
      // font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/no-result/no-result.vue